import TimeDropdown from './TimeDropdown';
import { ScheduleInterval } from './WorkSchedulerTypes';
import './WorkScheduler.css';

export type ScheduleTimeRow = {
  key: string;
  label: string;
  intervals: ScheduleInterval[];
};

type ScheduleTimeRowsProps = {
  rows: ScheduleTimeRow[];
  showEndTime?: boolean;
  isDisabled?: boolean;
  onTimeChange: (key: string, idx: number, field: 'start' | 'end', value: string) => void;
  onAdd: (key: string) => void;
  onRemove: (key: string, idx: number) => void;
};

function ScheduleTimeRows({
  rows,
  showEndTime = false,
  isDisabled = false,
  onTimeChange,
  onAdd,
  onRemove,
}: ScheduleTimeRowsProps) {
  return (
    <div className="ws-schedule-rows">
      {rows.map(({ key, label, intervals }) => (
        <div key={key} className="ws-day-row">
          <span className="ws-day-label">{label}</span>

          <div className="ws-intervals">
            {intervals.map((interval, idx) => (
              <div key={idx} className="ws-interval">
                <TimeDropdown
                  value={interval.start}
                  onChange={(val) => onTimeChange(key, idx, 'start', val)}
                  disabled={isDisabled}
                />

                {showEndTime && (
                  <>
                    <span className="ws-dash">—</span>
                    <TimeDropdown
                      value={interval.end || '17:00'}
                      onChange={(val) => onTimeChange(key, idx, 'end', val)}
                      disabled={isDisabled}
                    />
                  </>
                )}

                {intervals.length > 1 && (
                  <button
                    className="ws-remove-btn"
                    onClick={() => onRemove(key, idx)}
                    disabled={isDisabled}
                    type="button"
                    title="Remove interval"
                  >
                    <i className="fa-solid fa-minus" />
                  </button>
                )}
              </div>
            ))}
          </div>

          <button
            className="ws-add-btn"
            onClick={() => onAdd(key)}
            disabled={isDisabled}
            type="button"
            title="Add interval"
          >
            <i className="fa-solid fa-circle-plus" />
          </button>
        </div>
      ))}
    </div>
  );
}

export default ScheduleTimeRows;
